import templateUrl from "./sort-grid.html";
import map from "lodash/map";
import filter from "lodash/filter";

export const sortGridComponent = {
  bindings: {
    onEdit: "&",
    onView: "&",
    sortBy: "<",
    details: "<",
    onDelete: "&",
    sortOrder: "<",
    onColumnSort: "&",
    onColumnClick: "&",
    isRowClickable: "<",
  },
  templateUrl,

  controller: class SortGridComponent {
    $onInit() {
      this.defaultSortOrder = "";
      //assign unique id to each data object
      this.details.data = map(this.details.data, (value, index) => {
        value.sortId = index;
        value.isSelected = value.isSelected || false;
        value.isEdit = value.isEdit || false;
        value.isView = value.isView || false;
        value.isDelete = value.isDelete || false;
        return value;
      });
    }

    //sort column after clicking on column
    sort(fieldName) {
      const columnDetails = filter(
        this.details.config.columnDefs,
        ({ field }) => field === fieldName
      );

      //sort only enable column `enableSort` property must be `true` for sorting
      if (columnDetails.length > 0 && columnDetails[0].enableSort) {
        const _sortOrder =
          this.sortBy === fieldName && this.sortOrder === "asc"
            ? "desc"
            : "asc";
        this.sortColumns(fieldName);
        this.onColumnSort({ fieldName, sortOrder: _sortOrder });
      } else {
        this.onColumnSort({ fieldName });
      }
    }

    sortColumns(fieldName) {
      if (this.defaultColumn === fieldName) {
        if (this.defaultOrder === "ASC") {
          this.defaultOrder = "DESC";
          this.orderBy = "-" + this.defaultColumn;
        } else {
          this.defaultOrder = "ASC";
          this.orderBy = this.defaultColumn;
        }
      } else {
        this.defaultColumn = fieldName;
        this.defaultOrder = "ASC";
        this.orderBy = this.defaultColumn;
      }
      return this.defaultOrder;
    }

    onColumnCellClick(data, fieldName) {
      this.onColumnClick({ $event: data, fieldName });
    }

    _onViewMore(data) {
      this.details.data = this.details.data.map((value) => {
        if (data.id === value.id) {
          value.isOpen = true;
        }
        return value;
      });
    }

    _onViewMoreLocation(data) {
      this.details.data = this.details.data.map((value) => {
        if (data.id === value.id) {
          value.isLoctionOpen = true;
        }
        return value;
      });
    }

    _onViewLessLocation(data) {
      this.details.data = this.details.data.map((value) => {
        if (data.id === value.id) {
          value.isLoctionOpen = false;
        }
        return value;
      });
    }

    _onViewLess(data) {
      this.details.data = this.details.data.map((value) => {
        if (data.id === value.id) {
          value.isOpen = false;
        }
        return value;
      });
    }

    onActionButtonClick(e, data, type) {
      e.stopPropagation();
      const value = { $event: data };
      if (type === "edit") {
        this.onEdit(value);
      } else if (type === "view") {
        this.onView(value);
      } else if (type === "delete") {
        this.onDelete(value);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/sort-grid/sort-grid.component.js